import React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import SimpleMantenedorLayout from '../../components/SimpleMantenedorLayout';
import { useMantenedores } from '../../context/MantenedoresContext';
import { useTarifariosErroresDetalleMantenedor } from '../../hooks/useTarifariosErroresDetalleMantenedor';
import ErroresTarifariosDetalleComponent from '../../components/Tarifarios/ErroresTarifariosDetalleComponent';

const ErroresTarifariosDetallePage = () => {
    const { tipoTarifarioId } = useParams();
    const history = useHistory();
    const user = useSelector(state => state.auth.user);
    const { userPermissions } = useMantenedores();
    const permisos = userPermissions?.modules?.tarifarios || {};

    const {
        detalleErrores,
        loading,
        error,
        regionId,
        regiones,
        tiposVehiculo,
        handleRegionChange,
        handleSavePrecios,
        savingPrecios
    } = useTarifariosErroresDetalleMantenedor(user, permisos, tipoTarifarioId);

    const handleBack = () => {
        history.push('/mantenedores/tarifarios/errores');
    };

    return (
        <SimpleMantenedorLayout
            mantenedorId="tarifarios"
            title={`Errores de Tarifario - ${detalleErrores?.tipo_tarifario?.descripcion || 'Cargando...'}`}
            subtitle="Corrección masiva de errores de tarifario"
            iconColor="#dc3545"
            showBackButton={false}
            backButtonPath="/mantenedores/tarifarios/errores"
            breadcrumbs={[
                {
                    label: 'Tarifarios',
                    path: '/mantenedores/tarifarios'
                },
                {
                    label: 'Errores de Tarifario',
                    path: '/mantenedores/tarifarios/errores'
                },
                {
                    label: 'Detalle de Errores'
                }
            ]}
        >
            {error && <div className="alert alert-danger mb-2">{error}</div>}
            
            <ErroresTarifariosDetalleComponent
                detalleErrores={detalleErrores}
                loading={loading}
                regionId={regionId}
                regiones={regiones}
                tiposVehiculo={tiposVehiculo}
                onRegionChange={handleRegionChange}
                onSavePrecios={handleSavePrecios}
                savingPrecios={savingPrecios}
                onBack={handleBack}
            />
        </SimpleMantenedorLayout>
    );
};

export default ErroresTarifariosDetallePage;
